import { cva } from '@flipster/styled-system/css';

export const rankingStyle = cva({
  variants: {
    rank: {
      1: {
        bg: 'rgba(var(--key-color-rgb), 0.2)',
      },
      2: {
        bg: 'rgba(var(--key-color-rgb), 0.1)',
      },
      3: {
        bg: 'rgba(var(--key-color-rgb), 0.05)',
      },
      default: {
        bg: 'transparent',
      },
    },
  },
});
